import React, { createContext, useState } from 'react';
import { accessTokenRequest, sendRequest } from '../global/global.service';
import { urlConfig } from '../../config/urlConfig';

export const AuthenticationContext = createContext();

export const AuthenticationContextProvider = ({ children }) => {
  const [userData, setUserData] = useState(null);
  const [userPreferTime, setUserPreferTime] = useState(null);

  const getUserTimeZone = () => {
    accessTokenRequest()
      .then((response) => {
        sendRequest(urlConfig.time_algorithm_url, response, 'get', null)
          .then((res) => {
            setUserPreferTime(res.data);
          })
          .catch();
      })
      .catch();
  };

  const savePreferTime = (setIsLoading, setShow) => {
    setIsLoading(true);
    accessTokenRequest()
      .then((response) => {
        sendRequest(
          urlConfig.time_algorithm_url,
          response,
          'post',
          userPreferTime
        )
          .then((res) => {
            setUserPreferTime(res.data);
            setIsLoading(false);
            setShow(true);
          })
          .catch((e) => {
            setIsLoading(false);
            setShow(false);
          });
      })
      .catch((e) => {
        setIsLoading(false);
        setShow(false);
      });
  };

  return (
    <AuthenticationContext.Provider
      value={{
        userData,
        userPreferTime,
        setUserPreferTime,
        setUserData,
        getUserTimeZone,
        savePreferTime,
      }}
    >
      {children}
    </AuthenticationContext.Provider>
  );
};
